import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  fireGoogleAnalytics,
  GA_PAGEVIEW,
  isConfiguredForGoogleAnalyticsTracking,
} from '../../core/analytics/trackingForPartners';

export default class GoogleAnalytics extends PureComponent {
  componentDidMount = () => this.fireAnalytics();

  componentDidUpdate = () => this.fireAnalytics();

  hasFiredAnalytics = false;

  fireAnalytics = () => {
    if (!this.hasFiredAnalytics) {
      const { location } = this.props;

      if (isConfiguredForGoogleAnalyticsTracking(location)) {
        fireGoogleAnalytics(location, GA_PAGEVIEW);
        this.hasFiredAnalytics = true;
      }
    }
  };

  render = () => null;
}

GoogleAnalytics.propTypes = {
  location: PropTypes.object,
};
